import config from '@/utils/config'

export const hasExpedients = state => {
  let expedients = state.expedients.array.list
  if (!expedients) return false
  return expedients.length > 0 || !config.features.hasFactoring
}
